export default __webpack_public_path__ + "static/media/active-icon.e9a47c89.svg";